import { customElement, html } from '@adobe/edex/ui/edex-lit';
import { EdexTagName, CDN_PREVIEWS_FOLDER, CDN_UPLOADS_FOLDER } from '@adobe/edex/ui/shared/constants';
import { BaseElement } from '@adobe/edex/ui/components/base.element';
import { FileSchema, PreviewType } from '@adobe/edex/ui/types';
import { mime2previewType, getFileIconUrl, noticeError } from '@adobe/edex/ui/utils';
import { getExtension } from '@adobe/edex/ui/shared/utils';

import(
  /* webpackChunkName: "component/file-thumbnail-element-styles" */
  /* webpackMode: "lazy" */
  '@adobe/edex/ui/components/shared/file-thumbnail/file-thumbnail.scss'
);

const PREVIEW_EXTENSIONS = new Set(['pdf', 'docx', 'xlsx', 'pptx', 'odt', 'ods', 'odp']);

export function getPreviewURL(url: string) {
  if (!PREVIEW_EXTENSIONS.has(getExtension(url))) {
    return null;
  }
  try {
    const instance = new URL(`${url}.png`);
    if (instance.pathname.includes(CDN_UPLOADS_FOLDER)) {
      instance.pathname = instance.pathname.replace(CDN_UPLOADS_FOLDER, CDN_PREVIEWS_FOLDER);
    } else {
      instance.pathname = `/${CDN_PREVIEWS_FOLDER}${instance.pathname}`;
    }
    return instance.toString();
  } catch (err) {
    noticeError(err);
    return null;
  }
}

@customElement(EdexTagName.fileThumbnail)
export class FileThumbnail extends BaseElement {
  get useLightDom() {
    return true;
  }

  static get properties() {
    return {
      file: { type: Object },
    };
  }
  file: Pick<FileSchema, 'mimeType' | 'storagePath' | 'label'>;

  renderPreviewIcon() {
    const { file } = this;

    return html`
      <img class="preview-icon" src="${getFileIconUrl(file)}" alt="${file.label}" />
    `;
  }

  render() {
    const {
      file: { mimeType, storagePath },
    } = this;
    const previewType = mime2previewType(mimeType);
    const previewURL = previewType === PreviewType.image ? storagePath : getPreviewURL(storagePath);

    return html`
      <div class="default-document-preview">
        ${previewURL
          ? html`
              <object class="preview-thumbnail" data="${previewURL}" type="image/png">
                ${this.renderPreviewIcon()}
              </object>
            `
          : this.renderPreviewIcon()}
      </div>
    `;
  }
}
